package com.kinoshazam.view

import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import utils.FormFactor

@Composable
fun ProvideFormFactor(
    modifier: Modifier = Modifier,
    isAndroidTv: Boolean = false,
    content: @Composable BoxScope.(State<FormFactor>) -> Unit
) {
    BoxWithConstraints(modifier.fillMaxSize()) {
        // Web's first layout pass is often 0×0. Mounting the tree as Compact and
        // swapping a frame later cancels in-flight Compose resource loads. On web
        // that cancellation sticks: icons and strings stay empty until the next
        // locale change restarts them (CMP-10137).
        val measured = maxWidth > 0.dp && maxHeight > 0.dp
        val current = if (measured) {
            formFactorFor(maxWidth, maxHeight, isAndroidTv)
        } else {
            null
        }
        val ff = remember { mutableStateOf(current ?: FormFactor.Compact) }
        // Publish the measured factor before the tree mounts. A write in this
        // pass restarts composition, so the window is composed only once the
        // stored factor already matches — otherwise the restart cancels the
        // first resource loads.
        val settled = current != null && ff.value == current
        if (current != null && !settled) {
            ff.value = current
        }
        if (settled) {
            content(ff)
        }
    }
}

private fun formFactorFor(maxWidth: Dp, maxHeight: Dp, isAndroidTv: Boolean): FormFactor {
    return when {
        isAndroidTv -> FormFactor.ExtraLarge
        maxWidth < 600.dp -> FormFactor.Compact
        maxWidth < 840.dp && maxHeight < 480.dp -> FormFactor.Compact
        maxHeight < 480.dp -> FormFactor.Compact
        else -> FormFactor.Expanded
    }
}

// TODO: решение с derivedStateOf!!!
//@Composable
//fun ProvideFormFactorDerived(
//    modifier: Modifier = Modifier,
//    content: @Composable (FormFactor) -> Unit
//) {
//    // 1) Живой размер контейнера в пикселях
//    var pxSize by remember { mutableStateOf(IntSize.Zero) }
//    val density = LocalDensity.current
//
//    // 2) Размер в dp как производное состояние (меняется только при изменении pxSize)
//    val dpSize by remember {
//        derivedStateOf {
//            with(density) {
//                DpSize(pxSize.width.toDp(), pxSize.height.toDp())
//            }
//        }
//    }
//
//    // 3) Форм-фактор тоже через derivedStateOf — меняется только при смене "корзины"
//    val formFactor by remember {
//        derivedStateOf {
//            when {
//                dpSize.width < CompactEnd -> FormFactor.Compact
//                dpSize.width < MediumEnd  -> FormFactor.Medium
//                else                      -> FormFactor.Expanded
//            }
//        }
//    }
//
//    // 4) Контент рисуем снаружи, чтобы он триггерился ТОЛЬКО при смене formFactor
//    Box(
//        modifier
//            .fillMaxSize()
//            .onSizeChanged { pxSize = it } // это дёргается на каждый ресайз — ок
//    )
//
//    // Отдаём вниз только formFactor — сменится редко (только при пересечении брейкпоинта)
//    content(formFactor)
//}